import React from "react";
import styles from "./styles.module.scss";

type HeadingTypes =
  | React.ComponentPropsWithoutRef<"h1">
  | React.ComponentPropsWithoutRef<"h2">
  | React.ComponentPropsWithoutRef<"h3">
  | React.ComponentPropsWithoutRef<"h4">
  | React.ComponentPropsWithoutRef<"h5">
  | React.ComponentPropsWithoutRef<"h6">;

export interface HeadingProps extends HeadingTypes {
  as: string;
  center?: boolean;
}

const Heading: React.FC<HeadingProps> = ({
  as,
  center,
  children,
  ...props
}) => {
  const CustomTag = `${as}`;
  return (
    <CustomTag {...(center && { className: styles.center })} {...props}>
      {children}
    </CustomTag>
  );
};

Heading.defaultProps = {
  as: "h1"
};

export { Heading };
